import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from './language-EN'
import cnLocal from './language-CN'
import enLocaleElement from 'element-ui/lib/locale/lang/en'
import cnLocaleElement from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n);

const messages = {
  en: {
    ...Object.assign(enLocale, enLocaleElement)
  },
  cn: {
    ...Object.assign(cnLocal, cnLocaleElement)
  }
}
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'cn',
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/assets/language/index.js